import screenDesignerProps from 'screenDesignerProps';

const sources = [
    {
        type: "panel", icon: "border_outer", label: "Panel", source: {
            styles: [{width: "100%", padding: "0", margin: "", minHeight: "50px"}],
            children: [],
        }
    },
    {
        type: "label", icon: "title", label: "Label", source: {
            properties: {label: 'Label'},
            styles: [{color: '', fontSize: '16px', textAlign: '', padding: '', width: '100%'}]
        }
    },
    {
        type: 'button', icon: "crop_16_9", label: "Button", source: {
            properties: {label: 'Button', shortcut: {}, type: 'default', icon: '', validateFields: false},
            styles: [{
                padding: "4px 10px 4px 10px",
                margin: "0px", background: "primary",
                variant: "contained", fontSize: '13px'
            }],
            events: [{event: '', actions: [{param: [{}]}]}],
        }
    },
    {
        type: "list", icon: "table_chart", label: "List", source: {
            properties: {},
            styles: [
                {width: '100%', height: '300px'},
                {height: '27px', fontSize: '16px'},
                {padding: '0 0 5px 10px'},
                {fontWeight: 'bold', fontSize: '14px', textAlign: 'left', background: '#fff'},
            ],
            events: [
                {
                    event: '', actions: [
                        {param: [{}]}
                    ]
                }],
            children: [
                {
                    type: "toolBarPanel",
                    styles: [{width: '100%'}],
                    children: []
                },
                {
                    type: "toolBarPanel",
                    styles: [{width: '100%'}],
                    children: []
                }
            ]
        }
    },
    {
        type: 'table', icon: 'table', label: "Table", source: {
            properties: {},
            styles: [{width: '100%'}],
            children: [
                {
                    type: 'tableTr', properties: {}, styles: [], children: [
                        {
                            type: 'tableTh',
                            styles: [{width: '50px'}],
                            children: []
                        },
                        {
                            type: 'tableTh',
                            styles: [{width: 'auto'}],
                            children: []
                        },
                        {
                            type: 'tableTh',
                            styles: [{width: 'auto'}],
                            children: []
                        },
                        {
                            type: 'tableTh',
                            styles: [{width: 'auto'}],
                            children: []
                        }
                    ]
                },
                {
                    type: 'tableTr', properties: {}, styles: [], children: [
                        {
                            type: 'tableTd',
                            styles: [{}],
                            children: []
                        },
                        {
                            type: 'tableTd',
                            styles: [{width: 'auto'}],
                            children: []
                        },
                        {
                            type: 'tableTd',
                            styles: [{width: 'auto'}],
                            children: []
                        },
                        {
                            type: 'tableTd',
                            styles: [{width: 'auto'}],
                            children: []
                        },
                    ]
                }
            ]
        }
    },
    {
        type: 'line', icon: "remove", label: "Line", source: {
            styles: [{color: '', padding: "10px 0px 10px 0px", fullWidth: '', width: '100%'}]
        }
    },
    {
        type: 'tabs', icon: "tab", label: "Tabs", source: {
            styles: [{indicatorColor: 'primary', width: '100%'}],
            children: [
                {
                    type: 'tab',
                    properties: {label: 'New Tab'},
                    styles: [{color: ''}],
                    children: [
                        {
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                padding: "0px",
                                margin: "",
                                minHeight: "50px",
                                textAlign: '',
                                flexGrow: 0
                            }],
                            children: [
                                {
                                    type: 'panel',
                                    styles: [{
                                        width: "100%",
                                        padding: "0px",
                                        margin: "",
                                        minHeight: "50px",
                                        textAlign: '',
                                        flexGrow: 0
                                    }],
                                    children: [],
                                }
                            ],
                        }
                    ]
                }]
        }
    },
    {
        type: 'field', icon: "text_fields", label: "Field", source: {
            properties: {label: 'Field', name: 'field', type: 'string', path: 'field'},
            styles: [
                {width: '250px', height: '', margin: '', fullWidth: false, hideLabel: false},
                {width: '100px', margin: '', fontSize: '14px'}],
        }
    },
    {
        type: 'checkbox', icon: "check_box", label: "Checkbox", source: {
            properties: {label: 'Checkbox', name: 'checkbox', path: 'checkbox'},
            styles: [
                {labelPlacement: 'start', size: 'medium'},
            ],

        }
    },
    {
        type: 'switch', icon: "toggle_on", label: "Switch", source: {
            properties: {label: 'Switch', name: 'switch', path: 'switch'},
            styles: [
                {labelPlacement: 'start', size: 'medium'},
            ],

        }
    },
    {
        type: 'fieldArray', icon: "view_comfy", label: "Input Table", source: {
            type: "fieldArray",
            properties: {arrayType: 'horizontal'},
            styles: [{width: '100%'}],
            children: [
                {
                    type: "field",
                    properties: {label: 'Field', name: 'field', type: 'string', path: 'field'},
                    styles: [
                        {width: '250px', height: '', margin: '', fullWidth: false, hideLabel: false},
                        {width: '100px', margin: ''}],
                }
            ]
        }
    },
    {
        type: 'image', icon: "wallpaper", label: "Image", source: {
            properties: {source: undefined},
            styles: [{
                width: "150px"
            }],
        }
    },
    {
        type: 'card', icon: "credit_card", label: "Card", source: {
            styles: [{
                width: "100%",
                height: '150px'
            }],
            children: []
        }
    },
    {
        type: 'block', icon: "grid_view", label: "Block", source: {
            styles: [{
                display: 'flex',
                width: "100%",
                height: '150px',
                padding: '',
                margin: '',
                background: '',
                overflow: 'auto'
            }],
            children: []
        }
    },
    {
        type: 'chat', icon: "chat", label: "Chat", source: {
            properties: {
                sourceId: "",
            },
            styles: [
                {width: '300px', height: '600px', margin: ''}
            ]
        }
    },
    {
        type: 'text', icon: "title", label: "Text", source: {
            properties: {label: 'Enter text'},
            styles: [{color: '', fontSize: '', textAlign: '', padding: ''}]
        }
    },
    {
        type: 'survey', icon: "question_answer", label: "Survey", source: {
            properties: {sourceId: "", path: "", showScoring: false},
            styles: [{
                width: "100%",
                shadowBoxVertical: '',
                shadowBoxHorizontal: '',
                shadowBoxBlur: '',
                shadowBoxSpread: '',
                shadowColor: '',
                padding: "5px 5px 5px 5px",
                margin: "",
                minHeight: "",
                borderTop: '',
                borderRight: '',
                borderBottom: '',
                borderLeft: '',
            }],
            children: [
                {
                    type: 'surveyHeader',
                    styles: [{
                        background: '#f7f7f7',
                        color: '',
                        fontSize: '',
                        fontWeight: '',
                        fontStyle: '',
                        textAlign: '',
                    }]
                },
                {
                    type: 'surveyQuestion',
                    styles: [{
                        background: '',
                        color: '',
                        fontSize: '',
                        fontWeight: '',
                        fontStyle: '',
                        textAlign: '',
                    }]
                },
                {
                    type: 'surveyScoring',
                    styles: [{
                        background: '',
                        color: '',
                        fontSize: '',
                        fontWeight: '',
                        fontStyle: '',
                        textAlign: '',
                    }]
                },
            ],
        }
    },
    {
        type: 'stepper', icon: "rule", label: "Stepper", source: {
            properties: {
                linear: false,
                submitLabel: "Submit",
                nextLabel: "Next",
                backLabel: "Back",
                cancelLabel: "Cancel",
                deleteLabel: "Delete",
            },
            styles: [{width: "100%", height: ""}],
            events: [{}],
            children: [
                {
                    type: 'step',
                    properties: {
                        label: "First Step",
                        isCompleted: ""
                    },
                    styles: [{}],
                    children: []
                },
                {
                    type: 'step',
                    properties: {
                        label: "Second Step",
                        isCompleted: ""
                    },
                    styles: [{}],
                    children: []
                }
            ]
        }
    },
    {
        type: 'embeddedScreen', icon: "dynamic_feed", label: "Built-In", source: {
            properties: {sourceId: ""},
            styles: [{
                width: "100%"
            }],
        }
    },
    {
        type: 'entity', icon: "select_all", label: "Entity", source: {type: "entity", properties: {name: ""}}
    },
    {
        type: 'context', icon: "menu", label: "Context", source: {type: "context", properties: {name: ""}}
    },
    {
        type: 'progress', icon: "hourglass_empty", label: "Progress",
        source: {
            type: "progress",
            properties: {
                type: "linear",
                source: ""
            },
            styles: [{
                width: '100%'
            }]
        },
    },
    {
        type: 'selectionCriteria', icon: "read_more", label: "Selection",
        source: {
            type: "selectionCriteria",
            properties: {
                listId: "",
                path: ""
            },
            styles: [{
                width: '100%'
            }]
        },
    },
    {
        type: 'feed', icon: "rss_feed", label: "Feed",
        source: {
            type: "feed",
            properties: {},
            styles: [{width: '100%'}]
        },
    },
    {
        type: 'feedPost', icon: "forum", label: "Post",
        source: {
            type: "feedPost",
            properties: {
                id: ""
            },
            styles: [{width: '100%'}]
        },
    },
    {
        type: 'forEach', icon: "recycling", label: "For Each",
        source: {
            type: "forEach",
            properties: {
                id: ""
            },
            styles: [{width: '100%', height: '300px'}]
        },
    },
    {
        type: 'actionsBar', icon: 'view_array', label: 'Actions',
        source: {
            type: 'actionsBar',
            properties: {
                entity: ""
            },
            styles: [{width: '100%'}],
            children: []
        }
    },
    {
        type: 'bottomMenu', icon: 'linear_scale', label: 'Bot. Menu',
        source: {
            type: 'bottomMenu',
            properties: {
                showLabels: true,
                activeTab: ''
            },
            styles: [{width: '100%'}],
            children: [
                {
                    type: "navigationItem",
                    properties: {label: "Nav Item", icon: "home"}
                }
            ]
        }
    },
    {
        type: 'maps', icon: 'map', label: 'Maps',
        source: {
            type: 'maps',
            properties: {mapCenter: '', zoom: 10},
            styles: [{width: '100%', height: '100%'}],
            children: []
        }
    },
    {
        type: 'marker', icon: 'fmd_good', label: "Marker",
        source: {
            type: 'marker',
            properties: {
                dataSource: '',
                locationField: '',
                icon: '',
                popupScreen: '',
                popupText: ''
            },
            styles: [{color: ''}]
        }
    },
    {
        type: 'circle', icon: 'location_searching', label: "Circle",
        source: {
            type: 'circle',
            properties: {
                dataSource: '',
                locationField: '',
                radiusField: '',
            },
            styles: [{color: ''}]
        }
    },
    {
        type: 'dropzone', icon: 'file_present', label: "Dropzone",
        source: {
            type: 'dropzone',
            properties: {
                acceptTypes: [],
                path: '',
                fileType: 'system',
                isArray: true,
                disabled: '',
                required: '',
                type: "dragAndSelect",
                label: 'Drag \'n\' drop some files here, or click to select files'
            },
            styles: [{
                width: '100%',
                height: '90px'
            }]
        }
    },
    {
        type: 'icon', icon: 'insert_photo', label: "Icon",
        source: {
            type: 'icon',
            properties: {
                icon: 'insert_photo'
            },
            styles: [{
                width: 'auto',
                height: 'auto',
                fontSize: '41px',
                color: ''
            }]
        }
    },
    {
        type: 'searchBar', icon: 'search', label: "Search Bar",
        source: {
            type: 'searchBar',
            properties: {
                list: ''
            },
            styles: [{
                width: '100%',
                height: 'auto',
            }]
        }
    },
    {
        type: 'header', icon: 'dns', label: "Header",
        source: {
            type: 'header',
            properties: {},
            styles: [{
                width: '100%',
                height: 'auto',
                background: 'rgba(0,0,0,0.3)',
                shadowColor: ''
            }]
        }
    },
    {
        type: 'footer', icon: 'dns', label: "Footer",
        source: {
            type: 'footer',
            properties: {},
            styles: [{
                width: '100%',
                height: 'auto',
                shadowColor: ''
            }]
        }
    },
    {
        type: 'sidebar', icon: 'view_sidebar', label: "Sidebar",
        source: {
            type: 'sidebar',
            properties: {},
            styles: [{
                width: 'auto',
                height: '100%',
                position: 'absolute',
                left: 0,
                top: 2
            }]
        }
    },
    {
        type: 'frame', icon: 'crop_free', label: "Frame",
        source: {
            type: 'frame',
            properties: {},
            styles: [{
                width: '100%',
                height: 'auto',
            }]
        }
    },
    {
        type: 'menu', icon: 'menu', label: "Menu",
        source: {
            type: 'menu',
            properties: {
                id: '',
                type: ''
            },
            styles: [{
                width: '100%',
                height: 'auto',
            }]
        }
    },
    {
        type: 'badge', icon: 'badge', label: "Badge",
        source: {
            type: 'badge',
            properties: {
                label: '',
            },
            styles: [{
                width: 'auto',
                height: 'auto',
                color: 'secondary',
                variant: 'string'
            }]
        }
    },
    {
        type: 'interval', icon: 'timer', label: "Interval Timer",
        source: {
            type: 'interval',
            properties: {
                interval: 10,
            },
        }
    },
    {
        type: 'radioGroup', icon: 'radio_button_checked', label: 'Radio Group',
        source: {
            type: 'radioGroup',
            properties: {
                label: 'Radio Group',
                path: '',
                itemsData: '',
                items: []
            },
            styles: [
                {
                    orientation: 'vertical',
                    labelPlacement: '',
                }
            ]
        }
    },
    {
        type: 'rating', icon: 'star', label: 'Rating',
        source: {
            type: 'rating',
            properties: {
                path: '',
                disabled: false,
                readOnly: false
            },
            styles: [
                {}
            ]
        }
    },
    {
        type: 'band', icon: 'crop_16_9', label: 'Band',
        source: {
            type: 'band',
            properties: {
                type: ''
            },
            styles: [
                {
                    height: '50px',
                    width: '100%'
                }
            ],
            children: []
        }
    },
    {
        type: 'pageBreak', icon: 'article', label: 'Page Break',
        source: {
            type: 'pageBreak',
            styles: [
                {
                    width: '100%'
                }
            ],
        }
    },
    {
        type: 'swiper', icon: "view_carousel", label: "Swiper",
        source: {
            type: "swiper",
            properties: {
                source: "",
                autoplay: true,
                pagination: true,
                slidesPerView: 5,
                spaceBetween: "50"
            },
            styles: [
                {width: '100%', height: '70px'}
            ],
            children: [
                {
                    type: "swiperItem",
                    styles: [
                        {
                            width: '100px',
                            height: '100%'
                        }
                    ],
                    children: []
                }
            ]
        }
    },
    {
        type: 'accordion', icon: "layers", label: "Accordion",
        source: {
            type: "accordion",
            properties: {
                source: "",
            },
            styles: [
                {width: '100%', height: '70px'}
            ]
        }
    },
    {
        type: 'options', icon: "settings_suggest", label: "Options",
        source: {
            type: "options",
            properties: {
                label: "Options",
                path: "",
                varSource: "",
                listSource: "",
                multiple: false,
            },
            styles: [
                {width: '100%', height: '70px'}
            ]
        }
    },
    {
        type: 'fullView', icon: "view_agenda", label: "Full View",
        source: {
            type: "fullView",
            properties: {
                entity: ""
            },
            styles: [
                {width: '100%', height: ''}
            ]
        }
    },
    {
        type: 'calendar', icon: "calendar_month", label: "Calendar",
        source: {
            type: "calendar",
            styles: [
                {width: '100%', height: '100%'}
            ]
        }
    },
    {
        type: 'serverTime', icon: "watch", label: "Server Time",
        source: {
            type: "serverTime",
            properties: {
                source: '{new Date()}',
                refreshTime: 1,
                format: '',
            },
            styles: [
                {width: '', height: '', fontSize: '16px', color: '#000000'}
            ]
        }
    },
    {
        type: 'webSocket', icon: "settings_ethernet", label: "Web Socket",
        source: {
            type: "webSocket",
            properties: {
                // source: '{new Date()}',
                // refreshTime: 1,
                // format: '',
            },
        }
    },
    {
        type: 'dataSource', icon: "source", label: "Data Source",
        source: {
            type: "dataSource",
            properties: {
                id: ""
            },
        }
    },
    {
        type: "camera", icon: "camera", label: "Camera", source: {
            styles: [{width: "250px", height: '250px'}],
            children: [],
        }
    },
    {
        type: "pdfReader", icon: "picture_as_pdf", label: "Pdf Reader", source: {
            properties: {
                source: ""
            },
            styles: [{width: "100%", height: '100%'}],
            children: [],
        }
    },
    {
        type: "shortcut", icon: "picture_as_pdf", label: "Shortcut", source: {
            properties: {
                source: ""
            },
            events: [{}]
        }
    },
    {
        type: "restrictions", icon: "lock", label: "Restrictions", source: {
            properties: {
                entity: "",
                dataSource: ""
            },
            events: [{}],
            styles: [{width: "100%"}]
        }
    },
    {
        type: "tree", icon: "account_tree", label: "Tree", source: {
            properties: {
                dataSource: ""
            },
            events: [{}],
            styles: [{width: "100%"}],
            children: [
                {},
                {}
            ]
        }
    },
];

export const ItemSources = sources.map(item => {
    const indexOfCustom = screenDesignerProps.findIndex(i => i.type === item.type);
    if (indexOfCustom !== -1) {
        let updatedItem = JSON.parse(JSON.stringify(item));
        const customStyles = screenDesignerProps[indexOfCustom];

        //apply custom styles
        if (customStyles && customStyles.styles && Array.isArray(customStyles.styles)) {
            updatedItem.source = {
                ...updatedItem.source,
                styles: updatedItem.source.styles.map((style, index) => {
                    if (customStyles.styles[index]) {
                        return {...style, ...customStyles.styles[index]}
                    }
                    return style;
                })
            }
        }

        /*
        * ....
        * ....
        * here we can update other props e.g "properties"
        * ....
        * ....
        * */

        return {
            ...item,
            ...updatedItem
        }
    }
    return item;
})

export const itemGroups = {
    general: {
        label: "General",
        items: ["panel", "card", "button", "label", "line"]
    },
    dataDisplay: {
        label: "Data Display",
        items: ["list", "image", "progress", "feed", "feedPost"]
    },
    dataEntry: {
        label: "Data Entry",
        items: ["field", "fieldArray", "text", "survey", "selectionCriteria", "restrictions", "chat", "checkbox", "dropzone"]
    },
    navigation: {
        label: "Navigation",
        items: ["tabs", "stepper", "bottomMenu"]
    },
    maps: {
        label: "Maps",
        items: ['maps', 'marker', 'circle']
    },
    otherComponents: {
        label: "Other Components",
        items: ["entity", "context", "forEach", "embeddedScreen", 'icon', 'searchBar', 'serverTime', 'dataSource', 'shortcut']
    },
    templates: {label: "Templates", items: ['actionsBar']}
};
